import React from "react";
import PropTypes from "prop-types";
import styles from "./index.module.scss";

const CustomArticleTextOnlyHero = ({
  customArticleTextOnlyHeroData = {}
}) => {
  const {
    title = "",
    subTitle = "",
    description = {}
  } = customArticleTextOnlyHeroData;

  const descriptionValue =
    description?.content?.[0]?.content?.[0]?.value || "";

  return (
    <section className={styles.section}>
      <div className={styles.wrapper}>
        <div className={styles.box}>

          {/* Left side */}
          <div className={styles.left}>
            <div className={styles.leftContent}>
              {subTitle && (
                <div className={styles.firstHeading}>{subTitle}</div>
              )}
              {title && (  
                <div className={styles.secondHeading}>{title}</div>
              )}  
            </div>
          </div>

          {/* Divider */}
          <div className={styles.divider} />

          {/* Right side */}
          <div className={styles.right}>
            <p className={styles.description}>
              {descriptionValue}
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

CustomArticleTextOnlyHero.defaultProps = {
  customArticleTextOnlyHeroData: {
    title: "",
    subTitle: "",
    description: { content: [{ content: [{ value: "" }] }] }
  }
};

CustomArticleTextOnlyHero.propTypes = {
  customArticleTextOnlyHeroData: PropTypes.shape({
    title: PropTypes.string,
    subTitle: PropTypes.string,
    description: PropTypes.shape({
      content: PropTypes.arrayOf(
        PropTypes.shape({
          content: PropTypes.arrayOf(
            PropTypes.shape({
              value: PropTypes.string
            })
          )
        })
      )
    })
  })
};

export default CustomArticleTextOnlyHero;